var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content", staticStyle: { "margin-left": "5px" } },
    [
      _c("div", { staticClass: "app-main-inner-row" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "triggers" },
          [
            _c("span", [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Search")))]),
            _c("el-input", {
              staticStyle: { width: "200px", margin: "0 10px" },
              attrs: {
                placeholder: _vm.$t(
                  "SystemMaintenance.PleaseEnterTheBranchOffice"
                )
              },
              on: { input: _vm.filterRowData },
              model: {
                value: _vm.likeName,
                callback: function($$v) {
                  _vm.likeName = $$v
                },
                expression: "likeName"
              }
            }),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: { click: _vm.showBranchSelectDialog }
              },
              [_vm._v("...")]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.showEditDialog(true)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
            ),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onCopy } },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Copy")))]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    return _vm.showEditDialog(false)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
            ),
            _c(
              "el-button",
              { attrs: { type: "danger" }, on: { click: _vm.remove } },
              [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    _vm.filter.pageNum = 1
                    _vm.toQuery()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.refresh")))]
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "section grid-wrapper", staticStyle: { height: "90%" } },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "grid-params": _vm.girdParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.girdParams = $event
              },
              "update:grid-params": function($event) {
                _vm.girdParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-wrapper" },
        [
          _c("cargo-pagination", {
            attrs: {
              total: _vm.total,
              page: _vm.filter.pageNum,
              limit: _vm.filter.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.filter, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.filter, "pageSize", $event)
              },
              pagination: function($event) {
                _vm.manualPage.paginationClick = true
                _vm.toQuery()
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "110px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "isOverrideable" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.editDialog.form.overrideable,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "overrideable", $$v)
                            },
                            expression: "editDialog.form.overrideable"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v(_vm._s(_vm.$t("SystemMaintenance.Yes")))
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v(_vm._s(_vm.$t("SystemMaintenance.No")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.Branch") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            "filter-method": _vm.dataFilter
                          },
                          on: { "visible-change": _vm.initOfficeList },
                          model: {
                            value: _vm.editDialog.form.officeId,
                            callback: function($$v) {
                              _vm.$set(_vm.editDialog.form, "officeId", $$v)
                            },
                            expression: "editDialog.form.officeId"
                          }
                        },
                        _vm._l(_vm.officeList, function(item) {
                          return _c("el-option", {
                            key: item.officeId,
                            attrs: {
                              label: _vm.isZh
                                ? "[" + item.code + "]" + item.chineseName
                                : "[" + item.code + "]" + item.englishName,
                              value: item.officeId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.Value") } },
                    [
                      _c("el-input", {
                        attrs: { "filter-chars": false },
                        model: {
                          value: _vm.editDialog.form.configValue,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "configValue", $$v)
                          },
                          expression: "editDialog.form.configValue"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("branch-select-dialog", {
        attrs: {
          visible: _vm.branchSelectDialog.visible,
          value: _vm.branchSelectDialog.value,
          "office-list": _vm.officeList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.branchSelectDialog, "visible", $event)
          },
          callback: _vm.branchSelectDialog.callback
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filters" }, [
      _c("span", { staticStyle: { "margin-top": "10px" } }, [
        _vm._v("编辑配置项:")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }